/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Vector3fPb } from "../eigen_lcm/Vector3f";
import { PointStatus_Enum, pointStatus_EnumFromJSON, pointStatus_EnumToJSON } from "./point_status";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface PlanPoint {
  point: Vector3fPb | undefined;
  normal: Vector3fPb | undefined;
  status: PointStatus_Enum;
}

function createBasePlanPoint(): PlanPoint {
  return { point: undefined, normal: undefined, status: 0 };
}

export const PlanPoint = {
  encode(message: PlanPoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.point !== undefined) {
      Vector3fPb.encode(message.point, writer.uint32(10).fork()).ldelim();
    }
    if (message.normal !== undefined) {
      Vector3fPb.encode(message.normal, writer.uint32(18).fork()).ldelim();
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PlanPoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.point = Vector3fPb.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.normal = Vector3fPb.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanPoint {
    return {
      point: isSet(object.point) ? Vector3fPb.fromJSON(object.point) : undefined,
      normal: isSet(object.normal) ? Vector3fPb.fromJSON(object.normal) : undefined,
      status: isSet(object.status) ? pointStatus_EnumFromJSON(object.status) : 0,
    };
  },

  toJSON(message: PlanPoint): unknown {
    const obj: any = {};
    if (message.point !== undefined) {
      obj.point = Vector3fPb.toJSON(message.point);
    }
    if (message.normal !== undefined) {
      obj.normal = Vector3fPb.toJSON(message.normal);
    }
    if (message.status !== 0) {
      obj.status = pointStatus_EnumToJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanPoint>, I>>(base?: I): PlanPoint {
    return PlanPoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanPoint>, I>>(object: I): PlanPoint {
    const message = createBasePlanPoint();
    message.point = (object.point !== undefined && object.point !== null)
      ? Vector3fPb.fromPartial(object.point)
      : undefined;
    message.normal = (object.normal !== undefined && object.normal !== null)
      ? Vector3fPb.fromPartial(object.normal)
      : undefined;
    message.status = object.status ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
